import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectPatientState} from '../../../store/app.states';
import {NotificationModel} from '../../../model/user/NotificationModel';
import {MatDialog} from '@angular/material/dialog';
import {InfoDialogComponent} from '../../user-actions/info-dialog/info-dialog.component';
import {MessagingService} from '../../../services/messaging.service';
import * as _moment from 'moment';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

import {ConfirmDialogComponent} from '../../user-actions/confirm-dialog/confirm-dialog.component';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {AuthService} from '../../../services/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  title = 'Notifiche';
  user = null;
  notifications: NotificationModel[];
  back = true;
  destination = '/landing';
  getAuthState: Observable<any>;
  getPatientState: Observable<any>;

  constructor(private store: Store<AppState>,
              private dialog: MatDialog,
              private messagingService: MessagingService,
              private authService: AuthService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getPatientState = this.store.select(selectPatientState);

    document.addEventListener('notification', () => {
      setTimeout(() => {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.notifications = this.user.notifications;
        if (this.notifications !== undefined && this.notifications !== null) {
          if (this.notifications.length > 0) {
            this.notifications = this.notifications.sort((n1, n2) => this.comparing(n1, n2));
          }
        }
      }, 500);
    });

    document.addEventListener('update-notification', () => {
      setTimeout(() => {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.notifications = this.user.notifications;
        if (this.notifications !== undefined && this.notifications !== null) {
          if (this.notifications.length > 0) {
            this.notifications = this.notifications.sort((n1, n2) => this.comparing(n1, n2));
          }
        }
      }, 200);
    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.notifications = this.user.notifications;
    if (this.notifications !== undefined && this.notifications !== null) {
      if (this.notifications.length > 0) {
        this.notifications = this.notifications.slice().sort((n1, n2) => this.comparing(n1, n2));
      }
    }
    console.log(this.notifications);
  }

  openNotification(notification: NotificationModel) {
    if (!notification.read) {
      this.messagingService.setReadOnServer(notification).subscribe(res => {
          if (res.status === 200) {
            console.log('update done');
            this.authService.pullUpdates();
            document.dispatchEvent(new CustomEvent('update-notification', {
              bubbles: false
            }));
          }
        },
        error => {
          console.log(error);
          this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
        });
    }

    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '700px',
      height: '300px',
      data: notification
    });

    dialogRef.afterClosed().subscribe(result => {
        console.log('Finestra chiusa');
        if (result === 'Rimuovi') {
          this.removeNotification(notification);
        }
      }
    );
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }



  removeNotification(notification: NotificationModel) {
    console.log(notification);
    this.messagingService.updateOnServer(notification).subscribe(d => {
      if (d.status === 200) {
        console.log('Notification removed');
        this.authService.pullUpdates();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('update-notification', {
            bubbles: false
          }));
        }, 500);
      }
    }, error => {
      this.messagingService.openErrorDialog('Sessione scaduta. Effettuare di nuovo l\'accesso.');
      console.log(error);
    });
  }

  comparing(n1: NotificationModel, n2: NotificationModel) {
    const first = n1.title.split(' ');
    const second = n2.title.split(' ');
    const d1 = moment(first[0] + ' ' + first[1], 'DD/MM/YYYY h:mm:ss').toDate().getTime();
    const d2 = moment(second[0] + ' ' + second[1], 'DD/MM/YYYY h:mm:ss').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }

  removeAll() {
    const message = 'Confermando questa operazione, tutte le notifiche verranno rimosse';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '700px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
      if (result === 'SI') {
        this.messagingService.removeAllNotifications(this.user.email).subscribe(d => {
          if (d.status === 200) {
            console.log('Notifications cleared');
            this.user.notifications = [];
            this.notifications = this.user.notifications;
            localStorage.setItem('user', JSON.stringify(this.user));
            document.dispatchEvent(new CustomEvent('update-notification', {
              bubbles: false
            }));
          }}, error => {
          this.messagingService.openErrorDialog('Sessione scaduta. Effettuare di nuovo l\'accesso.');
          console.log(error, 'error in removing');
        });
      }
    });
  }
}
